'use client'

import { ArrowLeftRight } from '@repo/ui/icons'
import { cn } from '@repo/ui/lib/utils'

export const BrokerIcon = ({ className, size = 16 }: { className?: string; size?: number }) => (
  <ArrowLeftRight
    aria-label={'Broker'}
    className={cn('text-muted-foreground', className)}
    role={'img'}
    size={size}
  data-sentry-element="ArrowLeftRight" data-sentry-component="BrokerIcon" data-sentry-source-file="broker-icon.tsx" />
)
